import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import GlobalStyles from "@mui/material/GlobalStyles";
import Routes from "./routes";
import { FullScreenLoader } from "@app.automotus.io/components/FullScreenLoader";

export const App: React.FC = () => {
  const { isLoading } = useAuth0();

  return (
    <>
      {/* Hoisted above FullScreenLoader (not a child of it) since FullScreenLoader
       * discards its children entirely while loading — these rules must stay mounted
       * during Auth0's initial loading screen too, since Zendesk's snippet loads
       * independently via a plain <script> tag and can render its launcher before
       * Auth0 resolves. Hides the floating Zendesk launcher bubble, its unread-count
       * badge, the messenger panel, and the proactive greeting ("Hi. Need any help?",
       * a "Close message"/"Message from company" iframe pair CurbPass's Zendesk account
       * shows unprompted — AUT-5564) everywhere by default: superseded by the
       * full-screen chat on /support, where SupportChat's own GlobalStyles makes the
       * panel visible again, and just visually distracting elsewhere. */}
      <GlobalStyles
        styles={{
          "iframe#launcher": { display: "none !important" },
          'iframe[title="Number of unread messages"]': { display: "none !important" },
          'iframe[name="Messaging window"]': { visibility: "hidden !important" },
          'iframe[title="Close message"]': { display: "none !important" },
          'iframe[title="Message from company"]': { display: "none !important" },
        }}
      />
      <FullScreenLoader loading={isLoading}>
        <Routes />
      </FullScreenLoader>
    </>
  );
};

export default App;
